import { render, staticRenderFns } from "./address_panel.vue?vue&type=template&id=3b8b5b9c&scoped=true"
import script from "./address_panel.vue?vue&type=script&lang=js"
export * from "./address_panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b5b9c",
  null
  
)

export default component.exports